import React from "react";
import { Button, ButtonProps, styled, alpha } from "@mui/material";

// Create a styled Button component
const StyledButtonRoot = styled(Button)(({ theme }) => ({
  borderRadius: 12,
  padding: "10px 24px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "1rem",
  transition:
    "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  boxShadow:
    theme.palette.mode === "dark"
      ? `0 4px 6px -1px ${alpha(theme.palette.common.black, 0.3)}`
      : `0 4px 6px -1px ${alpha(theme.palette.primary.main, 0.2)}`,

  "&.MuiButton-contained": {
    backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: theme.palette.primary.contrastText,
    position: "relative",
    overflow: "hidden",

    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow:
        theme.palette.mode === "dark"
          ? `0 10px 15px -3px ${alpha(theme.palette.common.black, 0.4)}`
          : `0 10px 15px -3px ${alpha(theme.palette.primary.main, 0.3)}`,
      backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    },

    "&:active": {
      transform: "translateY(0)",
    },
  },

  "&.MuiButton-outlined": {
    borderWidth: 2,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,

    "&:hover": {
      borderWidth: 2,
      borderColor: theme.palette.primary.dark,
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      transform: "translateY(-2px)",
    },
  },

  "&.MuiButton-text": {
    color: theme.palette.primary.main,

    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      transform: "translateY(-1px)",
    },
  },

  "&:disabled": {
    opacity: 0.6,
    pointerEvents: "none",
  },
}));

const StyledButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledButtonRoot {...props}>{children}</StyledButtonRoot>;
};

export default StyledButton;
